import { Button, Checkbox, FormControlLabel, Grid } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import { Box } from '@mui/material'
import axios from 'axios'
import { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { sendValidationEmail } from '../../../actions/emailActions'
import { login } from '../../../actions/userActions'
import { USER_LOGIN_FAIL } from '../../../constants/userConstants'
import { useInput } from '../../../hooks/useInput'
import { Context } from '../../../providers/ProjectContextProvider'
import TextInput from '../../Form/TextInput'
import Loader from '../../Loader/Loader'
import ToastMessage from '../../ToastMessage/ToastMessage'

const SignIn = ({ firstLogin }) => {
  const history = useHistory()

  const dispatch = useDispatch()

  const { setShowContactSupport } = useContext(Context)

  const {
    value: email,
    bind: bindEmail,
    error: emailError,
    setError: setEmailError,
  } = useInput('')
  const {
    value: password,
    bind: bindPassword,
    error: passwordError,
    setError: setPasswordError,
  } = useInput('')
  const [rememberMe, setRememberMe] = useState(true)
  const [toast, setToast] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const { loading, error, userInfo, userLoggedOut } = useSelector(
    (state) => state.userLogin
  )

  const ValidateEmail = () => {
    return (
      <div>
        Email not validated.{' '}
        <span className="cursor underline" onClick={handleSendValidationEmail}>
          Click here to resend validation email.
        </span>
      </div>
    )
  }

  useEffect(() => {
    if (userInfo && !userLoggedOut) {
      if (firstLogin) {
        history.push('/completesignup')
      } else {
        history.push('/myquality/dashboard')
      }
    } else {
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: '',
      })
    }

    if (error === 'Pending') {
      setEmailError(<ValidateEmail />)
    }

    if (error === 'Incorrect email or password') {
      setEmailError('Incorrect email or password')
      setPasswordError('Incorrect email or password')
    }
  }, [
    userInfo,
    userLoggedOut,
    dispatch,
    firstLogin,
    error,
    setEmailError,
    setPasswordError,
    history,
  ])

  const formIsValid = () => {
    let ready = true

    if (email === '') {
      ready = false
      setEmailError('Please enter your email.')
    } else {
      setEmailError('')
    }

    if (password === '') {
      ready = false
      setPasswordError('Please enter your email.')
    } else {
      setPasswordError('')
    }
    return ready
  }
  const submitHandler = (e) => {
    e.preventDefault()

    if (formIsValid()) {
      dispatch(login(email.toLowerCase(), password, rememberMe))
    }
  }

  const handleSendValidationEmail = async () => {
    setToast(true)
    try {
      const { data } = await axios.get(`/api/users/registration/${email}`)
      dispatch(sendValidationEmail(data))
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <form onSubmit={submitHandler}>
        <div>
          {loading ? (
            <Loader />
          ) : (
            <>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextInput
                    name="email"
                    label="Email"
                    bindValue={bindEmail}
                    error={emailError}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextInput
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    label="Password"
                    bindValue={bindPassword}
                    error={passwordError}
                    endAdornment={true}
                    handleClick={() => setShowPassword(!showPassword)}
                    icon={showPassword ? <VisibilityOff /> : <Visibility />}
                  />
                </Grid>
              </Grid>
            </>
          )}

          <div className="flex space-between m-t-40">
            <div>
              <FormControlLabel
                className="fs14"
                control={
                  <Checkbox
                    name="Remember Me"
                    color="primary"
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)}
                  />
                }
                label="Remember me"
              />
            </div>

            <div>
              <Button variant="contained" color="primary" type="submit">
                Log in
              </Button>
            </div>
          </div>

          <Box>
            <Link className="underline fs12" to={'/forgotpassword'}>
              Forgot password
            </Link>
          </Box>
          <Box>
            <span
              className="link fs12"
              onClick={() => setShowContactSupport(true)}
            >
              Contact support
            </span>
          </Box>

          {error && error}
        </div>
      </form>

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Validation email sent</p>
            <p className="fs14 m-b-0">
              If you cannot locate the email, please check your spam folder.
            </p>
          </>
        }
        open={toast}
        setOpen={setToast}
      />
    </>
  )
}

export default SignIn
